import type { ReactNode } from 'react';

import { FileUp, FolderPlus, FolderUp } from 'lucide-react';
import { useCallback } from 'react';

import { ContextMenu, ContextMenuContent, ContextMenuGroup, ContextMenuItem, ContextMenuLabel, ContextMenuSeparator, ContextMenuTrigger } from '@/components/ui/context-menu';
import { useFilesStorage } from '@/store/files-store';

interface FilePageContextMenuProps {
  children: ReactNode;
  disabled?: boolean;
  onUploadFilesOpen?: () => void;
  onUploadDirOpen?: () => void;
}

export default function FilePageContextMenu(filePageContextMenuProps: FilePageContextMenuProps) {
  const { children, disabled = false, onUploadFilesOpen, onUploadDirOpen } = filePageContextMenuProps;

  const { setOpenCreateDir, permissions } = useFilesStorage();

  const handleOnCreateDir = useCallback(() => {
    setOpenCreateDir(true);
  }, [setOpenCreateDir]);

  return (
    <ContextMenu>
      <ContextMenuTrigger disabled={disabled}>{children}</ContextMenuTrigger>
      <ContextMenuContent>
        <ContextMenuLabel>Akcje</ContextMenuLabel>
        <ContextMenuSeparator />
        <ContextMenuGroup>
          <ContextMenuItem disabled={disabled || !permissions.write} onClick={handleOnCreateDir}>
            <FolderPlus className={'size-4'} />
            Stwórz folder
          </ContextMenuItem>
          <ContextMenuItem disabled={disabled || !permissions.write} onClick={onUploadFilesOpen}>
            <FileUp className={'size-4'} />
            Prześlij pliki
          </ContextMenuItem>
          <ContextMenuItem disabled={disabled || !permissions.write} onClick={onUploadDirOpen}>
            <FolderUp className={'size-4'} />
            Prześlij folder
          </ContextMenuItem>
        </ContextMenuGroup>
      </ContextMenuContent>
    </ContextMenu>
  );
}
